import Invite from '@/containers/invite/Index';

import { ROUTE_INVITE } from './names';


export default [
    {
        path: '/invite',
        name: ROUTE_INVITE,
        component: Invite,
        meta: {
            auth: true,
            title: '邀请会员约课',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/invite.js